/*
 * Public API Surface of component
 */

export * from './lib/geolocation/geolocation.service'
